/* @flow */

import * as React from 'react';
import { useSelector } from 'react-redux';

import Localizer from '../../../helpers/localization';
import ButtonFX from '../../buttons/ButtonFX';
import { HeightKind } from '../../buttons/types';
import { PictoFailure, PictoWarning } from '../../pictos/Element';
import Modal from '../modal';
import './NpvrHelpModal.css';
import { getNpvrTotalQuota } from './helpers';

// 80 hours of recordings
const DEFAULT_QUOTA = 80;

// Recordings are deleted after 3 months
const recordingAvailability = 1;

// Up to 2 recordings at the same time
const maxConcurrency = 2;

const NpvrHelpModal = (): React.Node => {
  const npvrTotalQuota = useSelector<string | null>((state) => getNpvrTotalQuota(state.npvr.npvrRecordingsFutureStatus));

  return (
    <Modal ariaLabel={Localizer.localize('accessibility.modal.npvr_help')} className='npvrHelp'>
      <div className='header'>{Localizer.localize('modal.npvr_help.title')}</div>
      <div className='helpContent'>
        <div className='sectionTitle'>{Localizer.localize('modal.npvr_help.principles.title')}</div>
        <ul>
          <li>{Localizer.localize('modal.npvr_help.principles.quota', { quota: npvrTotalQuota ?? DEFAULT_QUOTA })}</li>
          <li>{Localizer.localize('modal.npvr_help.principles.availability', { availability: recordingAvailability })}</li>
          <li>{Localizer.localize('modal.npvr_help.principles.concurrency', { concurrency: maxConcurrency })}</li>
          <li>{Localizer.localize('modal.npvr_help.principles.series_recording')}</li>
          <li>{Localizer.localize('modal.npvr_help.principles.series_episode_cancel')}</li>
          <li>{Localizer.localize('modal.npvr_help.principles.channels_without_npvr')}</li>
        </ul>
        <div className='sectionTitle'>{Localizer.localize('modal.npvr_help.visual_indicators.title')}</div>
        <ul className='noBullet'>
          <li>
            <div>
              <ButtonFX heightKind={HeightKind.Medium} isDisabled>
                {Localizer.localize('modal.npvr_help.visual_indicators.record_action')}
              </ButtonFX>
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.record')}</div>
            </div>
          </li>
          <li>
            <div>
              <ButtonFX heightKind={HeightKind.Medium} isDisabled>
                {Localizer.localize('modal.npvr_help.visual_indicators.delete_recording_action')}
              </ButtonFX>
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.delete_recording')}</div>
            </div>
          </li>
          <li>
            <div>
              <PictoFailure className='alertPicto failure' />
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.failure_exceeded_concurrency')}</div>
            </div>
          </li>
          <li>
            <div>
              <PictoFailure className='alertPicto failure' />
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.failure_out_of_quota')}</div>
            </div>
          </li>
          <li>
            <div>
              <PictoFailure className='alertPicto failure' />
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.failure_server')}</div>
            </div>
          </li>
          <li>
            <div>
              <PictoWarning className='alertPicto warning' />
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.warning_exceeded_concurrency')}</div>
            </div>
          </li>
          <li>
            <div>
              <PictoWarning className='alertPicto warning' />
              <div className='hint'>{Localizer.localize('modal.npvr_help.visual_indicators.warning_out_of_quota')}</div>
            </div>
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default NpvrHelpModal;
